<h4 class="m-t-20 m-b-10">
    <input type="checkbox" class="m-r-10" name="customerDetailCheck" (change)="validateSales($event.target.checked)" />
    {{ "Sales Agent Details" | translate }}
</h4>
<table style="background: #f7f7fc; border-radius: 3px; margin-top: 1rem;">
    <thead>
        <tr>
            <th>{{ "SALES AGENT NAME" | translate }}</th>
            <th>{{ "SALES STAFF ID" | translate }}</th>
            <th>{{ "STOCKING POINT BUSINESS NAME" | translate }}</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td>{{ awaitingEscalation.staffName || "--" }}</td>
            <td>{{ awaitingEscalation.staffDealerId || "--" }}</td>
            <td>{{ awaitingEscalation.stockingPointBusinessName || "--" }}</td>
        </tr>
    </tbody>
</table>